export function isUrlAbsolute(url: string): boolean {
  return /^https?:\/\//i.test(url);
}
